import React, {Component} from "react";
import {Link} from "react-router-dom";
import Comments from "./Comments";
import {LoadingImage} from "./App";
import {supabase} from "./supabaseClient";


class DiscordUnblock extends Component<any, any>{

    constructor(props: any) {
        super(props);
        this.state = {
            downloadCount: 0,
        };
    }

    componentDidMount() {
        this.fetchDownloadCount();
        document.title = "Soap Unblock";

        let link = document.querySelector("link[rel~='icon']");
        if(link != null) {
            link.setAttribute("href", "./discordicon.ico");
        }

        let top = document.querySelector(".Logo-holder");
        console.log(top)
        if(top != null) {
            top.setAttribute("src", "./discordicon.ico")
        }
    }

    fetchDownloadCount = async () => {
        try {
            const {data, error} = await supabase
                .from('counters')
                .select('value')
                .eq('key', 'discord_unblock_downloads')
                .single();
            if (error) throw error;
            this.setState({ downloadCount: data?.value ?? 0 });
        } catch (error) {
            console.error('Ошибка при получении данных о количестве скачиваний:', error);
        }
    };

    handleDownload = async () => {
        try {
            // Инициируем скачивание файла
            window.location.href = '/SoapUnblock.rar';

            // Инкрементируем счётчик
            await supabase.rpc('increment_counter', {counter_key: 'discord_unblock_downloads'});


        } catch (error) {
            console.error('Ошибка при отправке POST-запроса:', error);
        }
    };

    render() {
        return <>
            <header className="App-header">
                <p>Soap Unblock</p>
                <img src="https://i.imgur.com/RvwmA0e.png"></img>
                {/*<p>&#10071;&#10071;&#10071;  Программа была обновлена для работы с YouTube.  &#10071;&#10071;&#10071;</p>*/} {/*<s><br/> <img src="https://i.imgur.com/RvwmA0e.png"></img><br/> <br/> <br/>
                <p>Максимально простая в использовании программа для разблокировки доступа к Discord и YouTube.</p>
                <p>Не проксирует ваше соединение. Работает и для голосовых каналов.</p>
                <p>Все что нужно, скачать архив, <strong>разархивировать</strong>, запустить SoapUnblock.exe.</p>
                <p>По желанию можно добавить в автозапуск.</p>
                <p>Держать программу запущенной не обязательно. Открыли, запустили, закрыли. Разблокировка будет работать</p>
                </s>*/}

                <br/> {/*<div style={{marginTop: '0px'}}>
                    <button
                        onClick={this.handleDownload}
                        style={{
                            padding: '10px 20px',
                            backgroundColor: '#4CAF50',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontFamily: 'inherit', // Наследовать шрифт от родительского элемента
                            fontSize: 'inherit',
                        }}
                    >
                        Скачать
                    </button>
                </div>*/}

                <br/>
                <p>Количество скачиваний:</p>
                <p>{this.state.downloadCount == 0 ? <center>
                    <div className="loader"></div>
                </center> : this.state.downloadCount}</p>{/*<a target="_blank" rel="noreferrer" href="https://www.virustotal.com/gui/file/30f5054987ce414b19abe227600106e00faa9c8da750672d2bfa50df4d2c5994">Ссылка на Virustotal</a>
                <br/>(Онлайн проверка на вирусы)
                <p></p>
                <a target="_blank" rel="noreferrer" href="https://hipolink.me/swathingsoap">Донат (hipolink)</a>
                <br/>(Можете облагодарить донатом) <br/> <br/>
                <p>Если программа вам помогла, оставьте комментарий:</p>*/} <br/>
                <div className="Comments">
                    <Comments type="discord"/>
                </div>
            </header>


        </>;
    }
}


export default DiscordUnblock
